<div class="jumbotron centered-text">
  <b>{{data.selectEntities.count}}</b>
  {{ data.selectEntities.count | csPlural:'změna':'změny':'změn' + " způsobu vypořádání " }}
  {{ data.selectEntities.count | csPlural:'záboru bude':'záborů budou':'záborů bude' }}
  {{ getActionLabel(data.selectEntities.count) }}.
  <ng-container *ngIf="data.details.action === FinalSolutionStateEnum.REJECTED && data.details.note">
    <br/><span>Důvod: <em>{{data.details.note}}</em></span>
  </ng-container>
</div>

<span *ngIf="occupationUpdatePaused && data.details.action === FinalSolutionStateEnum.APPROVED" class="text-uppercase occupation-solution-warning">
  <i class="error-message fa fa-exclamation-triangle"></i>
  Aktualizaci dat nelze provést, probíhá aktualizace záborových dat. Důvod: {{ occupationUpdatePausedReason }}
</span>

<span *ngIf="!occupationUpdatePaused && data.details.action === FinalSolutionStateEnum.APPROVED && hasOtherChange" class="text-uppercase occupation-solution-warning">
  <i class="error-message fa fa-exclamation-triangle"></i>
  {{ "Pro " +  countOtherChange + "/" + data.selectEntities.count + " navrhovaných změn záborů budou po kliknutí na Potvrdit tyto úpravy provedeny. Akci nelze vrátit zpět." }}
</span>
